export const REACT_APP_PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "https://www.obersound.com";
export const REACT_APP_FUNCTIONS_URL = process.env.REACT_APP_FUNCTIONS_URL || "https://us-central1-obersound-staging.cloudfunctions.net";
//export const REACT_APP_FUNCTIONS_URL = "https://us-central1-obersound-staging.cloudfunctions.net";

export const NODE_ENV = process.env.NODE_ENV;

export default {
  REACT_APP_PUBLIC_URL,
  REACT_APP_FUNCTIONS_URL,
  NODE_ENV
}



// WEBPACK FOOTER //
// ./src/constants/env.js